import React, { ChangeEvent, createRef, RefObject, SyntheticEvent } from 'react';
import { compose } from 'react-apollo';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import ButtonSave from '@components/Form/ButtonSave';

export interface ProductImage {
    file_name: string;
    base64_image: string;
}

interface PropType {
    label: string;
    name: string;
    value: ProductImage;
    productId: string;
    onChange: (value: ProductImage, name: string) => void;
    onSave: (value: ProductImage) => Promise<any>;
}

class ProductImageField extends React.Component<PropType & InjectedIntlProps> {
    private fileInputRef: RefObject<HTMLInputElement> = createRef();

    private handleFile = (file: File, reader: any) => (e: any) => {
        this.props.onChange({file_name: file.name, base64_image: reader.result}, this.props.name);
    }

    private handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        if (e.target.files && e.target.files.length) {
            const file = e.target.files[0];
            const reader = new FileReader();
            reader.onloadend = this.handleFile(file, reader);
            reader.readAsDataURL(file);
        }
    }

    private onSave = (e: SyntheticEvent) => {
        e.preventDefault();
        this.props.onSave(this.props.value);
    }

    public render() {
        const { value } = this.props;
        return (
            <>
                <div className="col-sm-3">
                    <strong>{this.props.label}</strong>
                </div>

                <div className="col-sm-3">
                    {value.file_name}<br />
                    {value && <img src={value.base64_image} style={{width: '100%'}} />}
                </div>

                <div className="col-sm-3">
                    <input type="file" hidden={true} style={{display: 'none'}} ref={this.fileInputRef} onChange={this.handleChange} />
                    <button className="btn btn-primary btn-block" onClick={(e: SyntheticEvent) => {
                        e.preventDefault();
                        this.fileInputRef.current!.click();
                    }}>{this.props.intl.formatMessage({id: 'common.upload'})}</button>
                </div>

                <div className="col-sm-3">
                    <ButtonSave className="btn-block" disabled={!value.file_name || !value.base64_image} onClick={this.onSave} />
                </div>
            </>
        );
    }
}

export default compose(
    injectIntl,
)(ProductImageField);




// WEBPACK FOOTER //
// ./src/modules/Product/components/ProductImageField.tsx